// 默认过期时间
export const defaultTimeout = 30000;
// 稍长一点的过期时间
export const longTimeout = 60000;
// x-www-form-urlencoded数据类型
export const urlencodedDataType = 'application/x-www-form-urlencoded;charset=UTF-8';
// 默认json数据类型
export const defaultDataType = 'application/json;charset=UTF-8';

